import { render, staticRenderFns } from "./info-table.vue?vue&type=template&id=f0ffd35c&"
import script from "./info-table.vue?vue&type=script&lang=js&"
export * from "./info-table.vue?vue&type=script&lang=js&"
import style0 from "./info-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports